import React from 'react';
import Select from '../Shared/Select';
import styles from './ShippingLocation.module.css';
import ZipCodeInput from '../Shared/ZipCodeInput';
import { IShippingLocationProps, IFormChangeEvent } from '../../../../interfaces';
import { determineZipCodeLabel } from '../../../utils/determineZipCodeLabel';

const ShippingLocation = ({
  handleFormStateOnChange,
  countries,
  shipCountry,
  shipState,
  shipZip,
  shipZipError,
}: IShippingLocationProps) => {
  const handleSelectChange = (e: IFormChangeEvent) => {
    handleFormStateOnChange(e);
  };

  return (
    <div className={styles.shippingLocation} data-testid="shipping-details-section">
      <div className={styles.shippingLocationTitleWrapper}>
        <h4 className={styles.shippingLocationTitle}>
          Shipping Location&nbsp;
          <span className={styles.shippingLocationSubtitle}>Enter full address on next page</span>
        </h4>
      </div>
      <div className={styles.shippingLocationInputs}>
        <Select
          countries={countries}
          name="shipCountry"
          value={shipCountry}
          label="Country"
          handleOnChange={handleSelectChange}
          currentCountryCode={shipCountry}
          withPadding
          errorMessage="Please select a country."
        />
        <Select
          countries={countries}
          name="shipState"
          value={shipState}
          label="State"
          handleOnChange={handleSelectChange}
          currentCountryCode={shipCountry}
          withPadding
          errorMessage="Please select a state."
        />
        <ZipCodeInput
          label={determineZipCodeLabel(countries, shipCountry)}
          placeholder="Zip Code"
          maxLength={10}
          value={shipZip}
          handleInput={handleSelectChange}
          name="shipZip"
          type={shipCountry === 'US' ? 'number' : 'text'}
          errorMessage="Please enter a valid zip code."
          shipZipError={shipZipError}
        />
      </div>
    </div>
  );
};

export default ShippingLocation;
